export default {
      id: "icon-flecha-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "icons.a6b2d245f36e98afeaa57bfde99180cf.svg#icon-flecha",
      toString: function () {
        return this.url;
      }
    }